import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
export const refreshGiftsEnabled = () => { cached = api.get("/gifts/status").then((r) => r.data.enabled).catch(() => false); return cached; };

export function useGiftsEnabled() {
  const [on, setOn] = useState(null);
  useEffect(() => { (cached || refreshGiftsEnabled()).then(setOn); }, []);
  return on;
}

export function IfGifts({ children }) {
  return useGiftsEnabled() ? children : null;
}
